import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordEmailPanelCmsKey = 'ForgotPasswordTitle' | 'BackToSignIn';

export const ForgotPasswordEmailPanelCmsWithDefault: CmsObjectWithDefault<ForgotPasswordEmailPanelCmsKey> = {
    ForgotPasswordTitle: {
        cmsId: 76310,
        defaultTranslation: 'Forgot password',
    },
    BackToSignIn: {
        cmsId: 67070,
        defaultTranslation: 'Back to sign in',
    },
};
